
import React from 'react';

export const CloudDownload = ({
  className,
  color = '#4C43AA',
  height = '25',
  width = '25',
}: {
  className?: string;
  color?: string;
  height?: string;
  width?: string;
}) => (
  <svg 
    width={width}
    height={height}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path 
      d="M12.5 22.1003V13.1003M12.5 22.1003L9.99996 20.1003M12.5 22.1003L15 20.1003M5.53396 9.21731C4.58817 9.4553 3.76184 10.0305 3.21021 10.8347C2.65859 11.639 2.41964 12.6171 2.53827 13.5851C2.65689 14.5531 3.12492 15.4445 3.85443 16.0918C4.58393 16.7391 5.52469 17.0977 6.49996 17.1003H7.49996" 
      stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" 
    />
    <path 
      d="M16.3299 7.23831C15.9881 5.88488 15.1445 4.71205 13.97 3.95757C12.7956 3.20309 11.3782 2.9234 10.0052 3.17522C8.63215 3.42703 7.40625 4.1915 6.57598 5.31365C5.7457 6.4358 5.37318 7.83168 5.53392 9.21831C5.53392 9.21831 5.68692 10.1003 5.99992 10.6003"
      stroke={color}
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M17.5 17.1003C18.206 17.0998 18.904 16.9498 19.5479 16.6602C20.1917 16.3705 20.767 15.9478 21.2357 15.4198C21.7045 14.8918 22.0561 14.2705 22.2674 13.5968C22.4787 12.9232 22.545 12.2124 22.4618 11.5113C22.3786 10.8101 22.1479 10.1346 21.7848 9.52905C21.4217 8.92352 20.9345 8.40176 20.3552 7.9981C19.776 7.59443 19.1178 7.31803 18.424 7.18707C17.7302 7.05611 17.0166 7.07358 16.33 7.23831L15 7.60031"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);
